<template>
    <div>
        <div v-if="!innerIsReview">
            <v-fade-transition mode="out-in">
                <validation-provider
                    v-slot="{ errors }"
                    :name="label || 'This'"
                    :rules="rules"
                    v-bind="providerProps"
                    v-show="innerShouldShow"
                    :vid="'validate-' + fieldAssignmentId"
                    :ref="'validate' + fieldAssignmentId"
                >
                    <div v-if="innerLabel" class="font-weight-black" v-html="innerLabel"></div>
                    <span
                        class="field-directions"
                        v-if="directions"
                        v-html="directions"
                    ></span>
                    <v-otp-input
                        v-model="innerValue"
                        v-bind="[vProps, $attrs]"
                        :type="vProps.pin_type"
                        :length="length"
                        class="type-pin__otp"
                    >
                    </v-otp-input>
                </validation-provider>
            </v-fade-transition>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                <div v-if="innerValue">
                    <span v-html="innerValue"></span>
                </div>
                <div v-else>N/A</div>
            </type-review>
        </div>
    </div>
</template>

<script>
import formMixin from '../formMixin';
import TypeReview from './TypeReview';
// TODO: more validation

export default {
    name: 'TypePIN',
    mixins: [formMixin],
    inheritAttrs: false,
    props: {
        length: {
            type: Number | String,
            default: 4,
            required: false
        }
    },
    components: {
        TypeReview
    },
    mounted() {
        this.fieldLoaded(); // signal to the form we are loaded
    },
    computed: {
        defaults() {
            return {
                label: this.innerLabel,
                directions: this.directions,
                persistentHint: true
            };
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings,
                ...{
                    required:
                            !!this.validation_settings.required &&
                            !!this.innerShouldShow
                }
            } : {};
        }
    }
};
</script>

<style lang="scss">
@import '~vuetify/src/styles/main.sass';

@media #{map-get($display-breakpoints, 'sm-and-up')} {
    .type-pin__otp .v-input {
        max-width: 60px !important;
    }
}
</style>
